import GuideLayout from '@/components/Guides/GuideLayout';
import { ThemeProvider } from '@/context/ThemeContext';

export default function DocsLayout() {
  return (
    <ThemeProvider forceTheme="white" scoped>
      <GuideLayout guideType="docs" />
    </ThemeProvider>
  );
}
